{
  "version": 1,
  "asset_id": "08f7db42-ef71-4069-9cb5-aeb83948c60c",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/08f7db42-ef71-4069-9cb5-aeb83948c60c/hero-abstract-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/08f7db42-ef71-4069-9cb5-aeb83948c60c/hero-abstract-640.avif",
  "original_filename": "hero-abstract-640.avif",
  "size": 14051,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:25:55Z"
}
